import axios from "axios";
import Links from "../constants/Links";

const Supervisors = {
  generateMagicLink: async (lecturerId) => {
    return axios.post(
      Links.supervisors.generateMagicLink
        + lecturerId
        + Links.supervisors.magicLink
    );
  }
};

export default Supervisors;
